import { AxiosService } from '../config/config'
import { Endpoints } from '../config/endpoints'
import { IPayload } from '../../models/Global'
import { IPayStub, IGetPayStubsParams } from '../../models/PayStub'

export class PayStubsApi {
  constructor(private axios: AxiosService) {}

  getPayStubs = async (params?: IGetPayStubsParams) => {
    const response = await this.axios.get<IPayload<IPayStub[]>>(
      Endpoints.getPayStubs,
      params,
    )
    return response
  }

  getPayStub = async (id: number, params?: IGetPayStubsParams) => {
    const response = await this.axios.get<IPayload<IPayStub>>(
      Endpoints.getPayStub(id),
      params,
    )
    return response
  }
}
